import React, {useState} from "react";
import {Button, ButtonGroup, Col, Row} from "react-bootstrap";
import AuditSearchForm from "./AuditSearchForm";
import CardTable from "../table/CardTable";
import {fetchData} from "../../../client/Actions";
import {getUser} from "../../helpers/jwt";
import CustomCard from "../CustomCard";
import dateUtils from "../../helpers/dateUtils";
import {renderEditionDetails} from "../../helpers/auditEditionUtils";
import ConfirmIconButton from "../button/ConfirmIconButton";
import SatFormConfig from "../../pages/format/config/SatFormConfig";
import CardFormDetails from "../form/CardFormDetails";
import ManagementHistoryActions from "../../pages/management/history/ManagementHistoryActions";
import IconButton from "../button/IconButton";
import renderUtils from "../../helpers/renderUtils";
import { useModels } from "../../helpers/models";
import StoragePlaceInventory from "../../pages/storagePlace/StoragePlaceInventory";
import { useTranslation } from 'react-i18next';

const AuditTab = ({tab, setLoader}) => {
    const { t } = useTranslation();

    const [tableData, setTableData] = useState();
    const [filterSetDetailsContext, setFilterSetDetailsContext] = useState();
    const [filterDetailsContext, setFilterDetailsContext] = useState();
    const models = useModels();
    
    const infoAction = (column, row, history) => {
        if (tab.infoAction) {
            if (tab.infoAction.redirectTo) {
                var win = window.open(tab.infoAction.redirectTo(row), "_blank");
                win.focus();
            }
            if (tab.infoAction.showFilterSetDetails) {
                showFiltersSetDetails(row.businessId)
            }
            if (tab.infoAction.showFilterDetails) {
                showFiltersDetails(row.filterId)
            }
        }
    };


    function getColumns() {
        const basic = [
            {
                field: "date",
                label: t("common.date"),
                sort: "desc",
                width: 53
            },
            {
                field: "username",
                label: t("common.user"),
                sort: "desc",
                width: 53,

            },
            {
                field: "auditActionType",
                label: t("forms.action"),
                sort: "desc",
                width: 200,
                type: "enum",
                enumType: "auditActionType"
            },
            {
                field: "objectType",
                label: t("forms.action_object"),
                sort: "desc",
                width: 200,
                type: "enum",
                enumType: "enums/objectType"

            },
            {
                field: "moduleObjectDescription",
                label: tab.moduleObjectHeader,
                sort: "desc",
                width: 200,
                type: tab.moduleObjectType,
                enumType: tab.moduleObjectEnumType,
            },
            {
                field: "parentObjectDescription",
                label: tab.parentObjectHeader,
                sort: "desc",
                width: 200,
                type: tab.parentObjectType,
                enumType: tab.parentObjectEnumType,
                hide: !tab.parentObjectHeader
            },
            {
                field: "objectDescription",
                label: tab.objectHeader,
                sort: "desc",
                width: 200,
                hide: tab.hideObject,
            },
            {
                field: "description",
                label: t("common.details"),
                sort: "desc",
                width: 53,
                type: "custom",
                custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState, externalState2) {
                    if (row.auditActionType === "EDITION") {
                        return renderEditionDetails(row.description);
                    }

                    if (row.auditActionType === "SAT" || row.auditActionType === "SAT_ACCEPTATION") {
                        return <ButtonGroup>
                            <ConfirmIconButton variant="outline-primary"
                                               icon={"fa-info-circle "}
                                               modalSize={"md"}
                                               tooltip={t("common.details")}
                                               buttonsConf={{
                                                   save: t("common.continue")
                                               }}
                                               confirmTitle={t("forms.sat_details")}
                                               ready={true}
                                               form={
                                                   <CardFormDetails
                                                       width={12}
                                                       fields={SatFormConfig}
                                                       setLoader={setLoader}
                                                       withoutHeader={true}
                                                       shadow={false}
                                                       readonly={true}
                                                       api={"/format/sat/" + row.description}
                                                   />
                                               }
                            >
                                <i className="fas fa-info-circle text-white"/>
                            </ConfirmIconButton>
                        </ButtonGroup>;
                    }

                    if (row.auditActionType === "CLEANING"
                        || row.auditActionType === "STORAGE"
                        || row.auditActionType === "SERVICE_START"
                        || row.auditActionType === "SERVICE_END"
                        || row.auditActionType === "DIMENSIONING_START"
                        || row.auditActionType === "DIMENSIONING_END"
                        || row.auditActionType === "REVIEW"
                        || row.auditActionType === "WITHDRAWAL"
                        || row.auditActionType === "PART_WITHDRAWAL"
                        || (row.auditActionType === "CREATION" && row.objectType === "PART" && row.description)
                    ) {

                        let actionType = row.auditActionType;

                        if (actionType === "WITHDRAWAL" || actionType === "CREATION") {
                            actionType = "REPLACEMENT"
                        }

                        if (actionType === "PART_WITHDRAWAL") {
                            actionType = "PART_WITHDRAW"
                        }
                        const action = {
                            actionType: actionType,
                            details: row.description
                        }

                        return <ManagementHistoryActions
                            row={action}
                            history={history}
                            id={row.parentObjectId}
                            openInNew={true}
                        />;

                    }


                    if (row.auditActionType === "PART_PRODUCTION_START"
                        || row.auditActionType === "PART_PRODUCTION_END"
                        || row.auditActionType === "PRODUCTION_START"
                        || row.auditActionType === "PRODUCTION_END") {
                        return <IconButton variant={"outline-primary"}
                                           icon={"fa-info-circle"}
                                           tooltip={t("forms.production_details")}
                                           onClick={() => {
                                               const tmp = row.description.split(",")
                                               const lineId = tmp[1]
                                               const prodId = tmp[0]
                                               window.open("/#/production/" + lineId + "/history/" + prodId, "_blank")
                                           }}

                        />
                    }

                    if (row.auditActionType === "INVENTORY") {
                        return <StoragePlaceInventory
                            storagePlaceInventoryId={row.description}/>

                    }

                    if (row.auditActionType === "CHANGE_STATUS") {
                        return renderUtils.renderAlarmStatus(row.description);
                    }
                    if (row.auditActionType === "CREATION" && row.objectType === "FONT") {
                        return <IconButton
                            variant={"outline-primary"}
                            onClick={() =>
                                window.open("/#/font/" + row.objectId, "_blank")
                            }
                            tooltip={t("common.details")}
                            icon={models.font.icon}
                        />
                    }

                    if ((row.auditActionType === "INVENTORY_START" || row.auditActionType === "INVENTORY_END") && row.objectType === "FONT") {
                        return <IconButton variant={"outline-primary"}
                                           icon={"fa-info-circle"}
                                           tooltip={t("common.details")}
                                           onClick={() => {
                                               window.open("/#/font/" + row.objectId + "/inventory/" + row.description, "_blank")
                                           }}

                        />
                    }

                    if (row.auditActionType === "CREATION" && row.objectType === "FONT") {

                        return <IconButton
                            variant={"outline-primary"}
                            onClick={() =>
                                window.open("/#/font/" + row.objectId, "_blank")
                            }
                            tooltip={t("common.details")}
                            icon={models.font.icon}
                        />
                    }

                    return row.description
                }
            },
        ];


        const info =
            !tab.infoAction ? [] :
                [
                    {
                        field: "actions",
                        label: t("common.actions"),
                        sort: "desc",
                        width: 53,
                        type: "custom",
                        custom: function (column, row, history) {
                            return <Button as="a" variant="primary" size="sm" className="btn-circle ml-1 tableInfoBtn"
                                           role="button"
                                           onClick={() => infoAction(column, row, history)}>
                                <i className="fas fa-info-circle text-white"/>
                            </Button>;
                        }

                    }
                ];

        return basic
            .filter(c => !c.hide)
            .concat(tab.additionalFields).concat(info);
    }


    async function showFiltersDetails(filterId) {
        let filterDetails = await fetchData("filters/" + filterId);
        let dryer = await fetchData("dryers/" + filterDetails.dryerId);
        filterDetails.dryer = dryer;


        setFilterDetailsContext({
                filter: filterDetails,
                show: true
            }
        );
    }

    async function showFiltersSetDetails(businessId) {
        let filterSetDetails = await fetchData("filter/set/business/" + businessId);

        if (filterSetDetails) {
            setFilterSetDetailsContext({
                    filterSet: filterSetDetails,
                    show: true
                }
            );
        }


    }


    return (
        <>


            <Row>
                <Col className="pl-0">
                    <AuditSearchForm apiType={tab.type}
                                     storeSetter={setTableData}/>
                </Col>
            </Row>

            <CustomCard
                className={"mx-0 px-0"}
                withoutHeader={true}
                shadow={false}>
                <span className="badge badge-primary mr-3">{t("forms.tracking_report")}</span>
                <span className="text-secondary mr-1">{t("common.user")}</span>
                <span className="badge badge-primary mr-3">{getUser()}</span>
                <span className="text-secondary mr-1">{t("common.date")}</span>
                <span className="badge badge-primary mr-3">{dateUtils.getCurrentDate("-")}</span>
            </CustomCard>
            <Row>
                <Col className="pl-0">
                    <CardTable
                        withoutHeader={true}
                        className={"mt-2 p-0"}
                        columns={getColumns()}
                        initData={tableData}
                        setLoader={setLoader}
                        shadow={false}
                        // searchConf={[
                        //     {
                        //         field: "objectType",
                        //         fieldType: "text",
                        //         searchType: "contains"
                        //     }
                        // ]}
                    />
                </Col>
            </Row>


        </>
    );
};

export default AuditTab;
